import { Loader } from "@datagame/ui";
import { FC, ReactNode } from "react";

export type Nullable<T> = T | null | undefined;

type WithQueryLoaderProps = {
  error?: Nullable<Error>;
  isLoading: boolean;
  children: ReactNode;
};

export const WithQueryLoader: FC<WithQueryLoaderProps> = ({ error, isLoading, children }) => {
  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return <div>Something went wrong</div>;
  }

  return <>{children}</>;
};
